
























import Vue from 'vue';

import { useSave } from '@/composables';
import { BaseModuleEditor } from '../base';

export default Vue.extend({
  name: 'DivideEditor',
  mixins: [BaseModuleEditor],
  props: {
    id: {
      type: String,
      required: true,
    },
    path: {
      type: String,
      default: 'arrangement',
    },
  },
  setup(props: any) {
    const { buffer, save } = useSave(props, {
      path: props.path,
    });
    return {
      buffer,
      save,
    };
  },
});
